export default interface TenantUser {
    Id: string;
    UserName: string;
    Email: string;
    Roles: string[];
    UserType: number;
    Password: string;
}

export enum UserType {
    SelfServiceUser = 0,
    EntraIdUser = 1,
    IdentityCode = 2,
    EntraIdApp = 3
}